import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import { setSentryUser } from "@/lib/error-reporting";

export function SentryUserSync() {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    if (user) {
      setSentryUser({ id: user.id });
    } else {
      setSentryUser(null);
    }
  }, [user, isLoaded]);

  return null;
}
